<template>
  <div class="content-wrapper">
    <section class="p-3">
      <div class="package-wrap">
        <h1 class="page-title">My package</h1>
        <ul>
          <li>
            <p>Your current package</p>
            <h3>{{ packageInfo.package }} </h3>
          </li>
          <li>
            <p>Package price</p>
            <h3>£{{ packageInfo.monthlyAmount }}/Monthly</h3>
          </li>
          <li>
            <p>Included routers</p>
            <h3>{{ !_.isEmpty(packageInfo.includedProduct) ? packageInfo.includedProduct : '--' }}</h3>
          </li>
          <li>
            <p>Broadband speed</p>
            <div class="net-speed">
              <h3><span class="net-speed-icon"><img src="/assets/images/icon-upload.svg" alt="upload"></span> {{
                packageInfo.uploadSpeed }} Mbps</h3>
              <h3><span class="net-speed-icon"><img src="/assets/images/icon-download.svg" alt="download"></span> {{
                packageInfo.downloadSpeed }} Mbps</h3>
            </div>
          </li>
          <li>
            <p>Contract start date</p>
            <h3>
              {{ !_.isEmpty(packageInfo.contractStartDate) ? packageInfo.contractStartDate
                : "--"
              }}
            </h3>
          </li>
          <li v-if="packageInfo.addOns?.length > 0" v-for="(addOn, i) in packageInfo.addOns">
            <p>Add-on</p>
            <h3>{{ addOn }}</h3>
          </li>
          <li v-if="packageInfo.addOns == null || packageInfo.addOns?.length == 0">
            <p>Add-on</p>
            <h3>{{ '--' }}</h3>
          </li>
        </ul>
      </div>
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="agreement-box">
            <div>
              <img src="/assets/images/icon-document.svg" alt="document">
              <h4>Download agreement</h4>
              <p>Download your latest agreement here</p>
              <button class="btn" @click.prevent="downloadAgreement">Download</button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="agreement-box">


            <div v-if="!cancellationRequestSubmitted && showCancelContractModal" class="card-body">
              <h3>{{ buttonTitle }}</h3>
              <p>{{ buttonDescription }}</p>
              <a href="javascript:void(0);" class="btn" data-toggle="modal" data-target="#cancelContractModal">
                {{ buttonTitle }}
              </a>
            </div>

            <div v-else-if="showCancelContractModal">
              <img src="/assets/images/icon-no-internet.svg" alt="no internet">
              <h4>Cancellation Request Submitted</h4>
              <p>Your cancellation request is submitted at {{ submittedDate }}.</p>
            </div>

          </div>
        </div>
      </div>


      <div class="modal fade" id="cancelContractModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content upgrade-modal">
            <div class="modal-body">
              <h5 class="modal-title">Confirm Cancellation.</h5>
              <p>Are you sure you want to cancel the {{ buttonTitle.toLowerCase() }}?</p>
              <div class="d-flex">
                <button type="button" class="btn" data-dismiss="modal" aria-label="Close" ref="CloseBtn">
                  No
                </button>
                <button class="btn" @click.prevent="cancelOrderOrAgreement" :disabled="is_loading">
                  <span v-if="!is_loading">Yes</span>
                  <span v-else>
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Processing...
                  </span>
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="account-info">
              <div class="row mb-5">
                <div class="col-6 col-md-6">
                  <div class="average-speed">
                    <img
                      src="../../../public/assets/images/icon-download.svg"
                      alt="upgrade"
                    />
                    <h2 class="heading">{{ packageInfo.downloadSpeed }} MB</h2>
                    <p>Average speed</p>
                    <div class="average-speed-btn">
                      <button class="btn btn-block" type="button">
                        Download
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="average-speed">
                    <img
                      src="../../../public/assets/images/icon-upload.svg"
                      alt="upgrade"
                    />
                    <h2 class="heading">{{ packageInfo.uploadSpeed }} MB</h2>
                    <p>Average speed</p>
                    <div class="average-speed-btn">
                      <button class="btn btn-block" type="button">
                        Upload
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Your package</h3>
              <p>
                Following is your {{ companyName }}'s package and/or account
                related information.
              </p>
              <ul>
                <li>
                  <div>
                    <img
                      src="../../../public/assets/images/icon-user.svg"
                      alt=""
                    />
                  </div>
                  <h4>
                    Account holder <span>{{ accountInfo.username }}</span>
                  </h4>
                </li>
                <li>
                  <div>
                    <img
                      src="../../../public/assets/images/icon-package.svg"
                      alt=""
                    />
                  </div>
                  <h4>
                    Current package <span>{{ packageInfo.package }}</span>
                  </h4>
                </li>
                <li>
                  <div>
                    <img
                      src="../../../public/assets/images/icon-time.svg"
                      alt=""
                    />
                  </div>
                  <h4>
                    Contract start date
                    <span>{{
                      packageInfo.contractStartDate
                        ? packageInfo.contractStartDate
                        : "NA"
                    }}</span>
                  </h4>
                </li>
              </ul>

              <button
                class="btn"
                data-toggle="modal"
                data-target="#upgradeModal"
              >
                Upgrade package
              </button>
            </div>
            <div class="card download-agreement download-agreement">
              <div class="card-body">
                <h3>Download agreement</h3>
                <p>
                  Please download your latest agreement from here
                </p>
                <a class="btn btn-outline" @click.prevent="downloadAgreement"
                  >Download agreement
                </a>
              </div>
            </div>
            <div class="card download-agreement cancel-contract">
              <div v-if="!cancellationRequestSubmitted && showCancelContractModal" class="card-body">
                <h3>{{ buttonTitle }}</h3>
                <p>{{ buttonDescription }}</p>
                <a
                  href="javascript:void(0);"
                  class="btn"
                  data-toggle="modal"
                  data-target="#cancelContractModal"
                >
                  {{ buttonTitle }}
                </a>
              </div>
              <div v-else-if="showCancelContractModal" class="card-body">
                <h3>Cancellation Request Submitted</h3>
                <p>Your cancellation request is submitted at {{ submittedDate }}.</p>
              </div>
            </div>
              <div
                class="modal fade"
                id="upgradeModal"
                tabindex="-1"
                role="dialog"
                aria-hidden="true"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content upgrade-modal">
                    <div class="modal-body">
                      <img
                        src="../../../public/assets/images/icon-upgrade-package.svg"
                        alt=""
                      />
                      <h5 class="modal-title">Upgrade your package now.</h5>
                      <p>
                        A Ticket will be raised upon upgrade package request. One
                        of our Customer Care agent will follow your request as
                        soon as possible.
                      </p>
                      <div class="d-flex">
                        <button
                          type="button"
                          class="btn"
                          data-dismiss="modal"
                          aria-label="Close"
                          ref="CloseBtn"
                        >
                          No
                        </button>
                        <a class="btn" @click.prevent="upgradePackageRequest">Yes</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <div
              class="modal fade"
              id="cancelContractModal"
              tabindex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content upgrade-modal">
                  <div class="modal-body">
                    <h5 class="modal-title">Confirm Cancellation.</h5>
                    <p>Are you sure you want to cancel the {{ buttonTitle.toLowerCase() }}?</p>
                    <div class="d-flex">
                      <button
                        type="button"
                        class="btn"
                        data-dismiss="modal"
                        aria-label="Close"
                        ref="CloseBtn"
                      >
                        No
                      </button>
                      <button
                        class="btn"
                        @click.prevent="cancelOrderOrAgreement"
                        :disabled="is_loading"
                      >
                        <span v-if="!is_loading">Yes</span>
                        <span v-else>
                          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Processing...
                        </span>
                      </button>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal fade"
              id="responseModal"
              tabindex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content upgrade-modal">
                  <div class="modal-body">
                    <h5 class="modal-title">Request Status</h5>
                    <p ref="responseMessage">
                      {{ responseMessage }}
                    </p>
                    <div class="d-flex">
                      <button
                        type="button"
                        class="btn"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div> -->



    </section>
  </div>
</template>

<script>

import $ from 'jquery';
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { CommonAPI, SelfcareAPI } from "@/services/api";
export default {
  name: "MyPackageInfo",
  metaInfo: {
    title: "My Package Information",
  },
  components: {
    //
  },

  data: () => ({
    params: {},
    is_loading: false,
    responseMessage: "",
    cancellationRequestSubmitted: false,
    actionType: "",
    buttonTitle: "",
    buttonDescription: "",
    showCancelContractModal: true,
    submittedDate: "",
    orderNumber: "",
    companyName: process.env.VUE_APP_COMPANY_NAME || '',
  }),

  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }
 this.companyName = process.env.VUE_APP_COMPANY_NAME || '';
    this.FETCH_PACKAGE_INFO();
    this.FETCH_ACCOUNT_INFO();
    this.getOrderDetails();
    // this.checkCancellationRequest();
  },

  computed: {
    // ...mapGetters(["profile"]),
    ...mapGetters(["profile", "packageInfo", "accountInfo"]),
  },

  metaInfo() {
    return {
      title: this.companyName
        ? `My Package Information | ${this.companyName}`
        : "My Package Information",
    };
  },

  methods: {
    ...mapActions([
      "FETCH_PROFILE",
      "FETCH_PACKAGE_INFO",
      "FETCH_ACCOUNT_INFO",
    ]),

    downloadAgreement() {
      console.log("Agreement download");
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      console.log("Subscriber::", subscriber);
      if (subscriber) {
        //download_agreement
        axios
          .get("download_agreement", {
            params: {
              cuid: subscriber.id,
            },
          })
          .then((response) => {
            console.log("Response:::", response);
            if (response.data) {
              const linkSource = `data:application/pdf;base64,${response.data}`;
              const downloadLink = document.createElement("a");
              const fileName = "ContractDocument.pdf";

              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
            } else {
              this.$toaster.error("Contract Document not found!");
            }
          })
          .catch((error) => {
            console.error("Error fetching agreement:", error.response || error);
            this.$toaster.error(
              "Something went wrong!. Please, contact with system administrator."
            );
          });
      }
    },

    upgradePackageRequest() {
      const _this = this;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        _this.is_loading = true;
        axios
          .post("upgrade_package_request", {
            cuid: subscriber.id,
          })
          .then((response) => {
            console.log("response.data::", response.data);
            const responseData = response.data;
            // _this.responseMessage = response.data.message;
            _this.is_loading = false;
            if (
              responseData != null &&
              (responseData.code == 200 || responseData.status == 200)
            ) {
              _this.$toaster.success(responseData.message);
            }

            _this.$nextTick(() => {
              // $("#upgradeModal").modal("hide");
              _this.$refs.CloseBtn.click();
            });
          })
          .catch((error) => {
            console.log("error " + error);
            _this.is_loading = false;
            _this.$nextTick(() => {
              // $("#upgradeModal").modal("hide");
              _this.$refs.CloseBtn.click();
            });
          });
      }
    },

    showButtonText() {
      let _this = this;
      if (_this.actionType === "cancel_order") {
        _this.buttonTitle = "Cancel Order";
        _this.buttonDescription = `Please click "Cancel Order" to cancel your this order with us. `;
      } else if (_this.actionType === "cancel_agreement") {
        _this.buttonTitle = "Cancel Contract";
        _this.buttonDescription = `Please click "Cancel Contract" to cancel any of your contract with us.
           A Ticket will be raised and one of our agent will get back within 24 hours to notify your chages as per the current contract.`;
      }
      else {

      }
    },


    cancelOrderOrAgreement() {
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      let api_url = "/submit-order-cancel-request";
      this.is_loading = true;

      if (subscriber) {
        axios
          .post(api_url, {
            order_number: this.orderNumber,
            subscriber_id: subscriber.id,
          })
          .then((response) => {
            this.responseMessage = response.data?.message || "";

            this.is_loading = false;
            this.cancellationRequestSubmitted = true;
            this.$toaster.success(this.responseMessage);
            this.$nextTick(() => {
              this.$refs.CloseBtn.click();
            });

          })
          .catch((error) => {
            this.is_loading = false;
            this.responseMessage = "An error occurred while cancelling.";
            this.$toaster.error(this.responseMessage);
            this.$nextTick(() => {
              this.$refs.CloseBtn.click();
            });

          });
      }
    },


    checkCancellationRequest() {
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      let api_url = "/check-order-cancel-request";
      this.is_loading = true;
      if (subscriber) {
        axios
          .post(api_url, {
            order_number: this.orderNumber,
            subscriber_id: subscriber.id,
          })
          .then((response) => {
            this.cancellationRequestSubmitted = response.data?.status
              ? response.data?.status === "request_submitted"
              : false;
            this.is_loading = false;
            if (!this.cancellationRequestSubmitted) {
              this.actionType = response.data?.action_type || "";
              if (!this.actionType)
                this.showCancelContractModal = false;
              else
                this.showCancelContractModal = true;
              this.showButtonText();
            }
            else {
              const createdAt = new Date(response.data.created_at);
              this.submittedDate = response.data.created_at ? createdAt.toISOString().split('T')[0] : "";
            }
          })
          .catch((error) => {
            this.is_loading = false;
            console.log(error);
          });
      }
    },

    getOrderDetails() {
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      let query = {};
      query.cuid = subscriber ? subscriber.id : null;

      SelfcareAPI.getMyOrders(query)
        .then((response) => {
          this.is_loading = false;
          this.orderNumber = Array.isArray(response.data) && response.data[0] ? response.data[0].order_number : null;
          // console.log("Order Number", this.orderNumber);
          this.checkCancellationRequest();
        })
        .catch((error) => { })
        .finally(() => {
          this.is_loading = false;
        });
    },


  },
};
</script>
<style scoped></style>
